import React, { useCallback, useEffect, useRef } from 'react';
import { components } from 'react-select';
import ReactSelect from 'react-select/creatable';
import { useField } from '@unform/core';

import { ChevronDownIcon } from '../../../assets/svg/SVGComponents';

interface OptionType {
  label: string;
  value: string | number;
}

interface Props {
  name: string;
  dropdownIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  isMulti?: boolean;
  [key: string]: any;
}

const CreatableSelect: React.FC<Props> = ({
  name,
  dropdownIcon: Icon,
  ...rest
}) => {
  const selecRef = useRef<any>(null);
  const { fieldName, defaultValue, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selecRef.current,
      getValue: ref => {
        if (rest.isMulti) {
          if (!ref.state.selectValue) {
            return [];
          }
          return ref.state.selectValue.map(
            (option: OptionType) => option.value,
          );
        }

        if (!ref.state.selectValue || ref.state.selectValue.length === 0) {
          return '';
        }

        return ref.state.selectValue[0]?.value;
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  const DropdownIndicator = useCallback(
    (props: any) => {
      return (
        <components.DropdownIndicator {...props}>
          {Icon ? (
            <Icon width={13} strokeWidth={2} />
          ) : (
            <ChevronDownIcon width={13} strokeWidth={2} />
          )}
        </components.DropdownIndicator>
      );
    },
    [Icon],
  );

  return (
    <ReactSelect
      defaultValue={defaultValue}
      ref={selecRef}
      classNamePrefix="react-select"
      {...rest}
      components={{ DropdownIndicator }}
    />
  );
};

export default CreatableSelect;
